import hero from "./assets/hero.jpg"
import thumbnailHero from "./assets/thumbnailHero.jpg"


export const PhoenixTransitData = {
    title: "A 3-week Design Sprint for Phoenix Public Transit",
    heroImage: hero,
    thumbnailImage:thumbnailHero
}